import React, { ReactElement } from 'react'
import {
  DropdownIndicatorProps,
  GroupBase,
  OnChangeValue,
  components,
} from 'react-select'
import { StylesConfig } from 'react-select'
import Creatable from 'react-select/creatable'

import { ChevronDownIcon } from '@chakra-ui/icons'

import { topicsRef } from '../onboard/Interests/topicsReference'

interface TagOption {
  value: string
  label: string
}

const tagOptions = Object.keys(topicsRef).reduce(
  (res: TagOption[], val) => [
    ...res,
    { value: val, label: val },
    ...topicsRef[val].map((item) => {
      return { value: item, label: item }
    }),
  ],
  []
)

const DropdownIndicator = (
  props: DropdownIndicatorProps<TagOption, true, GroupBase<TagOption>>
) => {
  return (
    <components.DropdownIndicator {...props}>
      <ChevronDownIcon fontSize={'xl'} />
    </components.DropdownIndicator>
  )
}

interface Props {
  onChange: (newOptions: string[]) => void
  tags: string[]
}
const TagSelector = ({ onChange, tags }: Props): ReactElement => {
  const customStyles: StylesConfig<TagOption, true, GroupBase<TagOption>> = {
    control: (provided) => {
      return {
        ...provided,
        borderColor: 'rgb(226, 232, 240)',
        borderRadius: '6px',
        minHeight: '40px',
        display: 'flex',
        width: '100%',
        ':hover': {
          borderColor: 'rgb(226, 232, 240)',
        },
      }
    },
    menu: (provided) => {
      return {
        ...provided,
        boxShadow: 'none',
        borderColor: 'rgb(226, 232, 240)',
        borderWidth: '1px',
        borderRadius: '6px',
      }
    },
    option: (provided, { isFocused }) => {
      return {
        ...provided,
        backgroundColor: isFocused
          ? 'rgb(226, 232, 240)'
          : provided.backgroundColor,
      }
    },
    container: (provided) => {
      return {
        ...provided,
        display: 'flex',
        width: '100%',
      }
    },
    indicatorSeparator: (provided) => {
      return {
        ...provided,
        backgroundColor: 'rgb(237, 242, 247)',
        width: '2px',
      }
    },
    dropdownIndicator: (provided) => {
      return {
        ...provided,
        color: 'black',
      }
    },
  }

  //const [tags, setTags] = useState<string[]>([])

  const handleSelectTag = (
    newValues: OnChangeValue<TagOption, true>
    //_actionMeta: ActionMeta<TagOption>
  ) => {
    const newTags = newValues.map((t) => t.value)
    //  setTags(newTags)
    onChange(newTags)
  }

  const selectedTags: TagOption[] = tags.map((t) => {
    return { value: t, label: t }
  })

  return (
    <Creatable
      name="tags"
      value={selectedTags}
      options={tagOptions}
      isMulti
      onChange={handleSelectTag}
      closeMenuOnSelect={false}
      isClearable={true}
      maxMenuHeight={200}
      placeholder="Search or add tags"
      styles={customStyles}
      components={{ DropdownIndicator }}
      //classNamePrefix="creatable-select-chakra-styles"
    />
  )
}

export default TagSelector
